/**
 * Shared by the audit and anomaly tables, which formatted dates identically.
 * Deliberately not the app's useDateTimeFormat hook: these two screens print
 * the browser locale's full date-time, not the language-pinned short form.
 */
export const formatActivityDateTime = (iso: string | null): string => {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
};
